import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import { hasCallToAction } from '../utils';

import Grid from './Grid';
import Cell from './Cell';
import Block from './Block';
import CTAAnchor from './CTAAnchor';
import H2 from './H2';
import RichTextHtml from './RichTextHtml';
import CallOutArrow from './CallOutArrow';
import Backgrounder from './Backgrounder';

const PageCallOut = ({ content }) => {
  let titleColor = content.title_text_color;

  if (!content.title_text_color) {
    titleColor =
      content.title_background_color === 'blueDarker'
        ? 'coralLight'
        : 'blueDark';
  }

  return (
    <Block
      id={content.internal_link_id}
      backgroundColor="grayLight"
      position="relative"
    >
      <Backgrounder
        backgroundColor={content.title_background_color}
        position={content.title_position}
      />
      <Grid
        valign="center"
        flexDirection={{
          tablet: content.title_position === 'right' ? 'row-reverse' : 'row',
        }}
      >
        <Cell
          px={{ mobile: 'baseUp4', tablet: 'baseUp8' }}
          py={{ mobile: 'baseUp4', tablet: 'baseUp12' }}
          size={{ mobile: 1, tablet: 1 / 2 }}
          backgroundColor={content.title_background_color}
          position="relative"
        >
          <H2 color={titleColor} style={{ whiteSpace: 'pre-line' }}>
            {content.title1.text}
          </H2>

          <CallOutArrow
            backgroundColor={content.title_background_color}
            position={content.title_position}
            color={content.title_background_color}
          />
        </Cell>
        <Cell
          size={{ mobile: 1, tablet: 1 / 2 }}
          px={{ mobile: 'baseUp4', tablet: 'baseUp12' }}
          py={{ mobile: 'baseUp8', tablet: 'baseUp12' }}
        >
          <RichTextHtml html={content.text.html} />

          {hasCallToAction(content) ? (
            <Block pt="baseUp4">
              <CTAAnchor
                text={content.call_to_action_text.text}
                link={content.call_to_action_link}
                colorTheme={content.call_to_action_color}
              />
            </Block>
          ) : null}
        </Cell>
      </Grid>
    </Block>
  );
};

PageCallOut.propTypes = {
  content: PropTypes.shape({
    internal_link_id: PropTypes.string,
    title1: PropTypes.shape({ text: PropTypes.string }),
    title_text_color: PropTypes.string,
    title_background_color: PropTypes.string,
    title_position: PropTypes.string,
    text: PropTypes.shape({ html: PropTypes.string }),
    call_to_action_color: PropTypes.string,
    call_to_action_text: PropTypes.shape({ text: PropTypes.string }),
    call_to_action_link: PropTypes.shape({
      url: PropTypes.string,
      link_type: PropTypes.string,
      lang: PropTypes.string,
      target: PropTypes.string,
    }),
  }).isRequired,
};

export default PageCallOut;

export const query = graphql`
  fragment PageCallOutFragment on PrismicPageDataBodyCallOut {
    id
    slice_type
    primary {
      internal_link_id
      title_text_color
      title_background_color
      title_position
      title1 {
        text
      }
      text {
        html
      }
      call_to_action_color
      call_to_action_text {
        text
      }
      call_to_action_link {
        link_type
        url
        lang
        target
      }
    }
  }
`;
